import { render, staticRenderFns } from "./CatalogUpdate.vue?vue&type=template&id=a3e00654"
import script from "./CatalogUpdate.vue?vue&type=script&lang=js"
export * from "./CatalogUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports